export default __webpack_public_path__ + "static/media/job_benefit_dark.bfd28127.png";